<template>
     <div class="info">
       <b-icon icon="info-circle" :class="{'info-icon': true, 'danger': this.infoButtonClass == 'danger', 'warning': this.infoButtonClass == 'warning'}" id="infoCenter" />

        <b-popover target="infoCenter" triggers="click" placement="top">
          <template v-if="infoMessages">
            <b-alert :variant="msg.type" show v-for="(msg, idx) in infoMessages" :key="idx">
              {{msg.message}}
            </b-alert>

            <p v-if="infoMessages.length < 1"> {{ $t('infoMessages.noMessages') }} </p>
          </template>

          <b-skeleton animation="throb" v-else />
        </b-popover>
    </div>
</template>

<script>
export default {
    data: function() {
      return {
          infoMessages: []
      }
    },

    watch: {
      infoMessages: function(nVal) {
        nVal.filter(n => {
          return n.type == 'danger'
        }).forEach(v => {
          this.$bvToast.toast(v.message, {
            variant: 'danger',
            title: 'Notification',
            autoHideDelay: 2000
          })
        })
      }
    },

    computed: {
      infoButtonClass() {
          let danger = this.infoMessages.find(i => {
              return i.type == 'danger'
          })

          if (danger) return 'danger'

          let warning = this.infoMessages.find(i => {
              return i.type == "warning"
          })

          if (warning) return 'warning'

          return 'dark'
        }
    },

    mounted() {
        this.$store.dispatch("fetchSubscriptions").then(() => {
            this.$store.getters.getTrials.forEach(t => {
                const expiresAt = new Date(this.$toUserTimeZone(t.expires_at))
                const now = new Date()

                if (expiresAt > now) {
                  this.infoMessages.push({
                      message: this.$t('infoMessages.productTrialExpires', {name: t.license_product.name, expires: this.$toUserTimeZone(t.expires_at)}),
                      type: "warning"
                  })
                }
            })
        })

        this.$store.dispatch("fetchTrials")

        this.$store.dispatch("fetchProjectInfo").then(data => {
          const { component_storage = [] } = data || {}

          component_storage.forEach(c => {
            if (c.occupied_percent > 50 && c.occupied_percent < 80) {
              this.infoMessages.push({
                  message: this.$t('infoMessages.componentStorage', {component: this.$translateLabel(c.component.label, c.component.name), storage: c.occupied_percent.toFixed(2)}),
                  type: "warning"
              })
            }

            if (c.occupied_percent >= 80) {
              this.infoMessages.push({
                message: this.$t('infoMessages.componentStorage', {component: this.$translateLabel(c.component.label, c.component.name), storage: c.occupied_percent.toFixed(2)}),
                type: "danger",
              })
            }
          })
        })
    }
}
</script>

<style scoped lang="scss">

.info {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 10px;
  cursor: pointer;
  .info-icon {
    &.warning {
      color: yellow
    }

    &.danger {
      color: red
    }
  }
}
</style>